// CSS
import '../sass/pages/home.scss'

// === WP ALPHA ASSETS
import '@nematis/wp-alpha/assets/js/home'

// === Hero scrollytelling (chargé seulement si la section est présente)
if (document.getElementById('hero-scrolly')) {
  import(/* webpackChunkName: "hero-scrolly" */ './components/hero-scrolly')
    .then(({
      default: initHeroScrolly
    }) => initHeroScrolly())
}

// === Services : le scroll pilote le carousel (chargé seulement si la section est présente)
if (document.getElementById('services')) {
  import(/* webpackChunkName: "services-scroll" */ './components/services-scroll')
    .then(({
      default: initServicesScroll
    }) => initServicesScroll())
}
